import React from 'react';
import cn from 'classnames';
export const AccordionHeader = ({ title, subtitle, headerId, classNameHeader }) => {
    const mainHeader = cn(subtitle && 'cb-font-weight-medium');
    return (React.createElement("a", { href: "/#", className: cn('cb-accordion-heading', classNameHeader), id: headerId, role: "button" },
        React.createElement("div", { className: "cb-accordion-heading-title" },
            title && typeof title === 'string' ? React.createElement("span", { className: mainHeader }, title) : title,
            React.createElement("div", { className: "cb-accordion-icon" },
                React.createElement("span", { className: "line top" }),
                React.createElement("span", { className: "line bottom" }))),
        subtitle && React.createElement("p", { className: "cb-accordion-heading-content" }, subtitle)));
};
//# sourceMappingURL=AccordionHeader.js.map